var render, staticRenderFns
import script from "./FollowButton.vue?vue&type=script&lang=ts"
export * from "./FollowButton.vue?vue&type=script&lang=ts"
import style0 from "./FollowButton.vue?vue&type=style&index=0&id=bc191e50&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc191e50",
  null
  
)

export default component.exports